import type { SidebarItem } from './Sidebar';
import type { ModuleKey } from '@/lib/modules';

/**
 * Decides whether a sidebar item is visible for the current user.
 *
 * Module gating (display/UX only; the API is the enforcement authority): an item
 * tagged with a `module` is hidden only when `enabledModules` is a loaded array
 * that omits the key. While `enabledModules` is `null` (not yet loaded) a
 * module-tagged item stays visible — this avoids a flash-hide during hydration.
 * Permission checks still apply on top of module gating.
 */
export function isSidebarItemVisible(
  item: SidebarItem,
  _isAdmin: boolean,
  can: (permission: string) => boolean,
  canAny: (permissions: string[]) => boolean,
  enabledModules: ModuleKey[] | null = null,
): boolean {
  if (item.module && enabledModules !== null && !enabledModules.includes(item.module)) {
    return false;
  }
  if (item.anyPermissions?.length) return canAny(item.anyPermissions);
  if (item.permission) return can(item.permission);
  return true;
}
